import { EcItemSaleStatus, EcItemSaleStatusType } from '../types';

// 商品のステータスカラー
export const ecItemStatusColor = (status: EcItemSaleStatusType) => {
  return EcItemSaleStatus[status].labelColor;
};

// 改行とリンクをHTMLタグに変換
export const convertStr2HtmlTag = (text: string) => {
  // リンクを変換
  const linkPattern = /https?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/g;
  const urls = text.match(linkPattern);
  let replacedLinkText = text;
  if (urls) {
    urls.forEach(
      (url) =>
        // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
        (replacedLinkText = text.replaceAll(
          url,
          `<a href=${url} target="_blank" rel="noopener noreferrer nofollow">${url}</a>`,
        )),
    );
  }

  // 改行を変換
  let result = text;
  const brPattern = /\r\n|\n|\r/g;
  const brs = replacedLinkText.match(brPattern);
  if (brs) {
    brs.forEach(
      (br) =>
        // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
        (result = replacedLinkText.replaceAll(br, '<br>')),
    );
  }

  return result;
};

// 在庫数の表示テキスト
export const currentStockText = (currentStock: number) => {
  if (!currentStock || currentStock < 0) return '在庫あり'; //上限なし
  return currentStock < 6 ? `残り${currentStock}個` : '在庫あり';
};
